import * as React from "react";

function SvgCaretDown(props: React.SVGProps<SVGSVGElement>, svgRef?: React.Ref<SVGSVGElement>) {
  return <svg viewBox="0 0 16 16" ref={svgRef} {...props}><path d="M.393 5.188C-.3 4.5-.049 3.939.906 3.939h14.181c.973 0 1.208.553.512 1.249l-6.353 6.354a1.763 1.763 0 01-2.5 0z" fill="currentColor" fillRule="evenodd" /></svg>;
}

const ForwardRef = React.forwardRef(SvgCaretDown);
export default ForwardRef;